module.exports = __webpack_public_path__ + "img/comp-myPython.fb85f3bd.svg";